import React from 'react';
import { Select } from 'antd';
export interface PositonSelectBox {
  userPosition: string|undefined;
  onUserPosition: (value: string) => void;
}

const Position = ({
  userPosition,
  onUserPosition
}: PositonSelectBox): React.ReactElement => {
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Select 
      style={{width:"85px"}} 
      value={userPosition}
      placeholder="역할"
      onSelect={onUserPosition}
      options={[
        {
          value: 'A',
          label: '전체',
        },
        {
          value: 'CM',
          label: 'CM',
        },
        {
          value: 'PM',
          label: 'PM',
        },
        {
          value: 'OP',
          label: '운영자',
        },         
      ]}
    /> 
  );
};

export default Position;
